<template>
  <div>
    <div class="bg_class">
      <img src="~@/./assets/image/banner.png" />
      <h3>{{ config_data.guide_words }}</h3>
    </div>
    <div class="eva_box">
      <div class="stars evaList" v-if="config_data.type == EVALUATION_WAY.STAR">
        <li
          @click="changeClickPosition(item.grade)"
          v-for="item in config_data.comment_config"
          :key="item.grade"
        >
          <img
            :src="item.selectImgUrl"
            v-if="grade <= item.grade && grade != 0"
            alt=""
          />
          <img
            :src="item.unselectImgUrl"
            v-if="grade > item.grade || grade == 0"
            alt=""
          />
        </li>
      </div>
      <div class="exp evaList" v-if="config_data.type == EVALUATION_WAY.EXP">
        <li
          @click="changeClickPosition(item.grade)"
          v-for="item in config_data.comment_config"
          :key="item.grade"
        >
          <img :src="item.selectImgUrl" v-if="grade == item.grade" alt="" />
          <img :src="item.unselectImgUrl" v-if="grade != item.grade" alt="" />
        </li>
      </div>
      <div class="text evaList" v-if="config_data.type == EVALUATION_WAY.TEXT">
        <div
          :class="
            'textEvaItem' + (grade == item.grade ? ' textItemOnClick' : '')
          "
          v-for="item in config_data.comment_config"
          :key="item.grade"
          @click="changeClickPosition(item.grade)"
        >
          {{ item.content }}
        </div>
        <div
          class="textEvaItem textEvaItemEmpty"
          v-if="
            config_data.comment_config &&
              config_data.comment_config.length > 3 &&
              config_data.comment_config.length % 3 === 1
          "
        ></div>
        <div
          class="textEvaItem textEvaItemEmpty"
          v-if="
            config_data.comment_config &&
              config_data.comment_config.length > 3 &&
              config_data.comment_config.length % 3 > 0
          "
        ></div>
      </div>
      <div class="evaItems" v-if="grade != 0">
        <div>
          <p v-if="config_data.type != 1">{{ showText }}</p>
        </div>
        <el-radio-group
          v-model="grade_detail"
          size="large"
          class="items"
          v-if="child.length > 0"
          :disabled="grade === 0 || rateDisabled || endEvaluate"
        >
          <el-radio
            class="item"
            v-for="(cItem, cIndex) in child"
            :key="cIndex"
            :label="cItem"
          >
            {{ cItem }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="bottom">
        <el-button
          class="btn_submit"
          @click="handleSubmit"
          :disabled="grade === 0 || rateDisabled || endEvaluate"
        >
          {{ btnTitle }}
        </el-button>
        <p v-if="endEvaluate"></p>
      </div>
      <div v-show="is_show" class="message_show">
        <p>{{ info }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import authAPI from "@/api/auth";
const GRADE = {
  VERY_SATISFIED: 1, // 非常满意
  SATISFIED: 2, // 满意
  UNSATISFIED: 3, // 一般（不满意）
  UNSATISFIED_SERVICE: 4, // 服务不满意
  UNSATISFIED_OTHER: 5, // 其他不满意
  SATISFIED_NEW: 6, // 满意新版
  UNSATISFIED_NEW: 7, // 不满意新版
};
export default {
  title: "满意度评价",
  name: "satisfaction",
  data() {
    return {
      accessType: "mobile", //pc端 移动端
      btnTitle: "",
      endEvaluate: false,
      grade_detail: "",
      params: "",
      session_code: "",
      config_data: {},
      is_show: false,
      info: "",
      grade: 0,
      EVALUATION_WAY: {
        STAR: 2, // 星级评价
        EXP: 3, // 表情评价
        TEXT: 1, // 文字评价
      },
    };
  },
  methods: {
    // 历史评价消息回显
    handleHistoryRateMessageDisplay() {
      const record = this.session_code
        ? localStorage.getItem(this.session_code.toString())
        : "";
      if (record) {
        const recordObj = JSON.parse(record);
        // 处理历史数据的回显，兼容老数据的展示，满意度-新版（grade=6）当作非常满意
        if ([GRADE.VERY_SATISFIED].includes(recordObj.grade)) {
          this.grade = GRADE.VERY_SATISFIED;
        } else if (
          [GRADE.SATISFIED, GRADE.SATISFIED_NEW].includes(recordObj.grade)
        ) {
          this.grade = GRADE.SATISFIED;
        } else {
          this.grade = GRADE.UNSATISFIED_NEW;
        }
        this.grade_detail = recordObj.grade_detail || "";
      }
    },
    async getConfigForData(params) {
      try {
        let response_data = await authAPI.getSatisfactionConfig({
          sessionId: params.session_code,
          sign: params.sign,
          isApp: 0,
        });
        response_data = response_data.data;
        this.config_data = response_data;
        if (this.config_data && this.config_data.comment_config) {
          // 满意度位置  客户越满意（grade越小）显示的位置越靠左，星级评价正好相反
          this.config_data.type == this.EVALUATION_WAY.STAR
            ? this.config_data.comment_config.sort((a, b) => b.grade - a.grade)
            : this.config_data.comment_config.sort((a, b) => a.grade - b.grade);
        }

        if (
          response_data.grade == 0 &&
          response_data.expire_status != 1 &&
          this.config_data.comment_config
        ) {
          // 默认选中最高的满意度
          const defaultGradeIndex =
            this.config_data.type == this.EVALUATION_WAY.STAR
              ? this.config_data.comment_config.length - 1
              : 0;
          this.grade = this.config_data.comment_config[defaultGradeIndex].grade;
        } else {
          this.grade = response_data.grade;
        }

        this.btnTitle =
          this.config_data.grade != "0"
            ? "已评价"
            : this.config_data.expire_status == "1"
            ? "已过期"
            : "提交";

        if (this.config_data.grade == 0) {
          if (this.config_data.expire_status == 1) {
            this.btnTitle = "已过期";
          }
        } else {
          this.flag = true;
          this.grade = this.config_data.grade;
          this.btnTitle = "已提交";
        }

        this.session_code = this.session_code || this.config_data.sessionId;
        this.handleHistoryRateMessageDisplay();
      } catch (error) {
        this.$store.commit("showMessage", {
          type: "error",
          message: error,
        });
      }
    },
    async handleSubmit() {
      if (this.child.length > 0 && !this.grade_detail) {
        this.info = "请选择二级分类";
        this.is_show = true;
        setTimeout(() => {
          this.is_show = false;
        }, 3000);
        return;
      }
      let params = {
        sessionId: Number(this.session_code),
        grade: this.grade, // 1-非常满意 2-满意 3-一般（不满意） 4-服务不满意 5-其他不满意 6-满意新版 7-不满意新版
        grade_detail: this.grade_detail,
      };
      try {
        const res = await authAPI.saveSatisfactionGrade(params);
        if (res.data.code == 200) {
          this.endEvaluate = true;
          this.btnTitle = "已提交";
          localStorage.setItem(
            this.session_code.toString(),
            JSON.stringify(params)
          );
        }
        this.info = res.data.msg;
        this.is_show = true;
        setTimeout(() => {
          this.is_show = false;
        }, 3000);
      } catch (err) {
        this.is_show = true;
        this.info = err.info || err;
        setTimeout(() => {
          this.is_show = false;
        }, 1000);
      }
    },
    changeClickPosition(grade) {
      if (this.endEvaluate || this.rateDisabled) {
        return;
      } else {
        this.grade = grade;
        this.grade_detail = "";
      }
    },
  },
  computed: {
    rateDisabled() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.btnTitle =
        this.config_data.grade != "0"
          ? "已评价"
          : this.config_data.expire_status == "1"
          ? "已过期"
          : "提交";
      return (
        this.config_data.grade != "0" || this.config_data.expire_status == "1"
      );
    },
    showText() {
      let item = this.config_data.comment_config.find(
        (item) => item.grade == this.grade
      );
      if (item) {
        return item.content || "";
      }
      return "";
    },
    child() {
      let item = this.config_data.comment_config.find(
        (item) => item.grade == this.grade
      );
      if (item) {
        return item.child || "";
      }
      return [];
    },
  },
  created() {
    // 获取地址参数
    this.params = {
      session_code: this.$route.query.session_id,
      sign: this.$route.query.sign,
    };
    this.session_code = this.$route.query.session_id;
    this.getConfigForData(this.params);
  },
  destroyed() {
    this.tim.logout();
  },
  watch: {},
};
</script>

<style lang="less">
.el-radio__label {
  padding-left: 0;
}
.el-radio__input {
  display: none;
}
.message_show {
  font-size: 0.364rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4.05rem;
  height: 1rem;
  box-shadow: 0 0.104rem 0.521rem rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  border-radius: 0.051rem;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 0.2rem;
}

.message_show i {
  color: #21b34b;
  font-size: 0.416rem;
}

.bg_class {
  text-align: center;
}

.bg_class img {
  width: 100%;
}

.bg_class h3 {
  font-family: PingFangSC-Medium;
  font-size: 0.416rem;
  color: #333333;
  font-weight: 500;
  margin-top: 1rem;
  margin-bottom: 0.68rem;
}

.el-checkbox {
  margin-right: 0;
}

.eva_box {
  width: 9rem;
  background: #ffffff;
  border-radius: 0.21rem;
  margin: 0 auto;
  margin-bottom: 0.37rem;
}

.bottom {
  border-radius: 0.21rem;
}

.eva_box p {
  width: 4.375rem;
  height: 0.52rem;
  font-family: PingFangSC-Medium;
  font-size: 0.364rem;
  color: #333;
  text-align: center;
  font-weight: 500;
  margin: 0 auto;
}

.eva_box ul {
  width: auto;
  list-style: none;
  display: flex;
}

.eva_box img {
  width: 0.625rem;
  height: 0.625rem;
}

.eva_box li {
  margin-right: 0.625rem;
  list-style: none;
}

.eva_box li:last-child {
  margin-right: 0;
}

.evaList {
  width: 5.625rem;
  height: 0.625rem;
  margin: 0 auto;
  margin-top: 0.521rem;
  display: flex;
  justify-content: center;
}

.eva_box .btn_submit {
  width: 9.141rem;
  height: 1.198rem;
  line-height: 9px;
  background: #007eed;
  border-radius: 0.104rem;
  border: none;
  color: white;
  font-size: 0.469rem;
  font-weight: 400;
  margin: 0.625rem auto;
  position: relative;
  top: 30px;
}

.el-button.is-disabled {
  background: #dedede !important;
}

.eva_box .evaItems p {
  font-family: PingFangSC-Medium;
  font-size: 0.313rem;
  color: #555555;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 0.417rem;
}

.evaItems .item {
  width: 3.074rem;
  height: 0.678rem;
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 0.104rem;
  font-family: PingFangSC-Regular;
  font-size: 0.313rem;
  color: #666666;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.313rem;
}

.evaItems .item:nth-last-child(-n + 2) {
  margin-bottom: 0;
}

.evaItems .item:nth-child(2n) {
  margin-right: 0;
}

.evaItems {
  width: 100%;
  height: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.evaItems .item:nth-child(odd) {
  margin-right: 0.26rem;
}

.evaItems .items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.625rem;
  justify-content: center;
}

.bottom p {
  margin: 0.521rem auto;
  font-family: PingFangSC-Regular;
  font-size: 0.313rem;
  color: #999999;
  letter-spacing: 0;
  font-weight: 400;
}

.textEvaItem {
  width: 2.292rem;
  height: 0.729rem;
  border: 1px solid rgba(222, 222, 222, 1);
  border-radius: 0.104rem;
  font-family: PingFangSC-Regular;
  font-size: 0.313rem;
  color: #666666;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.201rem;
  margin-bottom: 0.201rem;
}

.textEvaItemEmpty {
  border: none;
}

.textEvaItem:nth-child(3),
.textEvaItem:last-child {
  margin-right: 0;
}

.text.evaList {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  height: auto;
  width: 100%;
}

.textItemOnClick {
  background: #007eed;
  color: #ffffff;
  border: none;
}

.item .el-checkbox__input {
  display: none;
}

.el-checkbox__label {
  padding-left: 0;
  font-size: 0.313rem;
}

.item.is-checked {
  color: #007eed;
  background: rgba(0, 126, 237, 0.1);
  border: 1px solid rgba(0, 126, 237, 1);
}

.message_show p {
  color: #ffffff;
}
</style>
